import React from 'react';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import Image from 'frontastic/lib/image';
import { NationalBook, NationalSemibold, Tiempos } from 'fonts';

const ResponsiveInline = (props: any) => {
    const { content } = props;
    const [windowWidth] = useMediaQuery();
    const maxWidth = windowWidth>1500 || windowWidth<800 ? 1300:windowWidth-280;
    const containerStyle = {
        maxWidth: `${maxWidth}px`
      };

      return (
        <div className={`our-product-container ${content.additional_css ?? ''}`} style={containerStyle}>
            <div className={`flex w-full gap-24 md:gap-24 xl:gap-48 2xl:gap-64 3xl:gap-64`}>
                {content.cards.map((card: any, index: number)=>(
                    <Link key={index} link={card.ctas?.[0]?.link?.href} className='w-full overflow-hidden relative h-auto hover:bg-[#D9D9D9]'>
                    {card.image && (
                    <div className="relative">
                        <div className="absolute z-10 bg-black opacity-20"></div>
                        <Image
                            priority
                            loading='eager'
                            src={encodeURI(card.image?.url)}
                            alt={card.image?.description}
                            sizes="100vw"
                            style={{
                            width: '100%',
                            height: 'auto',
                            maxWidth: '850px',
                            objectFit: 'cover',
                            }}
                            />
                    </div>
                    )}
                                        
                    <div className="px-[20px] pb-[10px]">
                    {card.title && (
                        <Typography
                        as="h4"
                        className={`mt-12 max-w-[90%] break-words text-22 font-medium leading-[30px] 
                        text-[#090909] md:text-18 lg:text-20 xl:text-18 2xl:text-22 
                        ${NationalSemibold.className}`}
                        >
                        {card.title}
                        </Typography>
                    )}
                    {card.description && (
                        <Typography as="p" className={`mt-12 font-normal leading-6 text-wrap text-16 xl:text-14 2xl:text-16 text-[#333] min-h-[50px] description ${NationalBook.className}`}>
                        {card.description}
                        </Typography>
                    )}
                    {card.ctas?.length > 0 && (
                        <div className='flex gap-1.5 flex-col group-hover:translate-x-14'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="green">
                            <path
                            d="M18 9L25 16M25 16L18 23M25 16L7 16"
                            stroke="#666666"
                            className="hidden group-hover:stroke-[#090909] md:block"
                            strokeWidth="2"
                            strokeLinecap="square"
                            />
                        </svg>
                        </div>
                    )}
                    </div>
                </Link>
              ))}
            </div>
        </div>
    )
};

export default ResponsiveInline;

